export default __webpack_public_path__ + "static/media/Chaosreaver.174b9781.jpg";